// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3GuF6","colMin":"styles_colMin__XBSYG"};